import {
  USERBET_ADDED,
  USERBET_REMOVED,
  USERBET_CHANGED,
  INITIAL_USERBETS_LOADED
} from 'actions/userbets'

export default function userbets(state = [], action) {
  switch (action.type) {
    case INITIAL_USERBETS_LOADED:
      return action.userbets.sort((a, b) => a.match.startTime - b.match.startTime)
    case USERBET_ADDED:
      if (state.filter(bet => bet.id === action.userbet.id).length === 0)
        return [...state, action.userbet].sort((a, b) => a.match.startTime - b.match.startTime)
    case USERBET_CHANGED:
      return state.map(userbet => userbet.id === action.userbet.id ? action.userbet : userbet)
    case USERBET_REMOVED:
      return state.filter(userbet => userbet.id !== action.id)
    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/userbets.js
 **/